<div class="label-container">
  <span class="label-text">{{ label$ | async }} </span>
  @if (pathLabel$ | async) {
    <mat-icon [matTooltip]="pathLabel$ | async" class="label-icon"
      >info_outline</mat-icon
    >
  }
</div>
